import { useTranslation } from 'react-i18next';
import { Modal, ScrollArea } from '@mantine/core';
import React from 'react';


type Props = {
    children: React.ReactNode,
    onClose?: () => void,
    opened?: boolean
    header?: React.ReactNode
    footer?: React.ReactNode
    size?: string
    withCloseButton?: boolean
    closeOnEscape?: boolean
    padding?: string
}

export default function CardModal({
    children,
    onClose,
    opened,
    header,
    footer,
    size,
    withCloseButton = true,
    closeOnEscape = true,
    padding,
}: Props) {
    return (
        <Modal
            trapFocus
            withCloseButton={withCloseButton}
            opened={opened}
            onClose={onClose}
            title={header}
            size={size || "100%"}
            padding="0"
            radius="lg"
            closeOnEscape={closeOnEscape}
            closeOnClickOutside={closeOnEscape}
            styles={{
                header: {
                    padding: '12px 24px 12px 24px',
                    borderBottom: '1px solid #dee2e6',
                    boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.1)',
                },
                title: {
                    width: '100%',
                    flex: 1,
                }
            }}
        >
            <div
                style={{
                    padding: padding || '24px 24px 24px 24px',
                }}
            >
                {children}
            </div>
            {footer && (
                <div
                    style={{
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: 'white',
                        borderTop: '1px solid #dee2e6',
                        padding: '12px 24px',
                        boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.1)',
                        borderRadius: '0 0 12px 12px',
                        zIndex: 10
                    }}
                >
                    {footer}
                </div>
            )}
        </Modal >
    );
}